module.exports = __webpack_public_path__ + "static/media/06-img@3x.2c76c367.png";